<template>
  <div class="productThird">
    <div class="detailTable">
      <el-table
        :data="tableData"
        style="width: 100%;margin: 0 auto;"
        :header-cell-style="{textAlign: 'center',background:'rgb(250, 35, 20)',color:'#393a39',color:'#fff',border:'none'}"

        :header-row-style="{height:'75px'}"
        :cell-style="{ textAlign: 'center' }">
        <el-table-column
          prop="date"
          label=""
          width="">
        </el-table-column>
        <el-table-column
          prop="name"
          label="伦敦金"
        >
        </el-table-column>
        <el-table-column
          prop="address"
          label="伦敦银"
        >
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name:'productThird',
  
  data() {
    return{
      tableData: [{
        date: '合约单位',
        name: '100',
        address: '5000'
      }, {
        date: '货币单位',
        name: 'USD',
        address: 'USD'
      },{
        date: '报价小数点',
        name: '2',
        address: '3'
      }, {
        date: '点差',
        name: '根据市况浮动',
        address: '根据市况浮动'
      }, {
        date: '单笔交易手数',
        name: '0.01手～20.00手',
        address: '0.01手～20.00手'
      },{
        date: '手数差值',
        name: '0.01手',
        address: '0.01手'
      }, {
        date: '最小挂单距离',
        name: '100点(根据市况浮动)',
        address: '100点(根据市况浮动)'
      },{
        date: '初始保证金',
        name: 'MT4：固定1000.00美元/手 \n MT5：合约价值*0.5%',
        address: 'MT4：固定1000.00美元/手 \n MT5：合约价值*0.5%'
      }, {
        date: '假期保证金',
        name: '双倍',
        address: '双倍'
      }, {
        date: '锁仓保证金',
        name: '按所需保证金较多的订单收取',
        address: '按所需保证金较多的订单收取'
      },{
        date: '库存费',
        name: '根据市况浮动',
        address: '根据市况浮动'
      },{
        date: '三天利息日',
        name: '周四',
        address: '周四'
      }, {
        date: '交易时间GMT+8',
        name: '周一：06:00-24:00 \n 周二：00:00-04:55 06:00-24:00 \n 周三：00:00-04:55 06:00-24:00 \n 周四：00:00-04:55 06:00-24:00 \n 周五：00:00-04:55 06:00-24:00 \n 周六：00:00-04:45',
        address: '周一：06:00-24:00 \n 周二：00:00-04:55 06:00-24:00 \n 周三：00:00-04:55 06:00-24:00 \n 周四：00:00-04:55 06:00-24:00 \n 周五：00:00-04:55 06:00-24:00 \n 周六：00:00-04:45'
      }, {
        date: '结算时间',
        name: '夏今：5点为结筤时间 \n 冬令：6点为结算时间',
        address: '夏今：5点为结筤时间 \n 冬令：6点为结算时间'
      }]
    }
  }
}
</script>

<style lang="less" scoped>
  .productThird{
    width: 100%;
    .detailTable{
      width: 100%;
      box-sizing: border-box;
      padding: 15px 0px 105px;
      margin: 0 auto;

      /deep/ .has-gutter {
        background: linear-gradient(to right, #FA2314, #DB2C23);
        tr {
          background: none;
          
          th {
            color: #FFFFFF;
            text-align: center;
            font-size: 20px;
          }
        }
      }
            /deep/      .el-table tbody tr:hover>td {
              background-color: transparent !important
            }
      /deep/ .el-table__row{
        height: 76px;
        td {
          &:nth-child(2) {
            color: #D18A1F;
            border-left: 1px solid #EBEEF5;
            border-right: 1px solid #EBEEF5;
          }
          &:nth-child(3) {
            color: #93939F;
          }
        }
      }
      /deep/ .el-table__row--striped{
        height: 76px;
      }
      /deep/ .el-table__row td:nth-child(1){
        font-weight: 600 !important;
      }
      /deep/ .el-table .cell {
        white-space: pre-line;
      }
      ::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td{
        // background: #f7f8fa;
      }
    }
  }
  @media screen and (max-width: 500px) {
    .productThird{
      margin:0 auto;
      // padding:0 1rem;
      .detailTable{
        /deep/ .has-gutter {
        background: linear-gradient(to right, #FA2314, #DB2C23);
        tr {
          background: none;
          
          th {
            color: #FFFFFF;
            text-align: center;
            font-size: 12px;
          }
        }
      }
      }
    }
  }
</style>